<template>
  <div class="param" style="padding: 0 1em;">
    <b-container class="news" style="padding: 0 1em;">
      <b-tabs content-class="mt-3">
        <b-tab active>
          <template #title>
            <b-icon icon="tools"></b-icon><strong>參數</strong>
          </template>
          <vCode/>
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import vCode        from '@/components/parameter/CodeView.vue'

export default {
  name: 'vParam',
  components: {
    vCode
  },
  created () {
    //console.log('== Param ==');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>